var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamtasia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8bc34a",
    d: "M39,42H9c-1.657,0-3-1.343-3-3V9c0-1.657,1.343-3,3-3h30c1.657,0,3,1.343,3,3v30 C42,40.657,40.657,42,39,42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 16l5-5h16.499c.445 0 .669.539.354.854L30.706 16H13zM13 32l5 5h16.499c.445 0 .669-.539.354-.854L30.706 32H13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcedc8",
    d: "M13 16H18V32H13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamtasia);
export default __webpack_public_path__ + "static/media/camtasia.ce20d56a0bcd99ae0b37fce765ed25ea.svg";
export { ForwardRef as ReactComponent };